<div
    class="box-section asp fixed inset-0 sm:static max-h-screen sm:max-h-[80vh] max-w-screen min-w-[200px] min-h-[280px] sm:inset-auto flex flex-col sm:rounded-2xl shadow-lg bg-white dark:bg-slate-900 sm:min-w-120 sm:w-120 md:min-w-200 md:w-200"
    [ngClass]="{ 'min-h-80': mostrarSpinner }"
    [style.--box-border-color]="color_primario || ''"
>
    <div class="w-full flex gap-4 justify-between items-center">
        <app-section-title [title]="title"></app-section-title>
        <div>
            <button mat-icon-button (click)="onCloseMenu(null)">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Skeleton Loader -->
    <div *ngIf="mostrarSpinner" class="w-full flex flex-col gap-4 p-4 overflow-y-auto flex-1 animate-pulse">
        <!-- Destinatario Skeleton -->
        <div class="h-14 bg-slate-100 dark:bg-slate-800/80 border border-slate-200/60 dark:border-slate-700/60 rounded-lg p-2.5 flex flex-col justify-between">
            <div class="w-20 h-2.5 bg-slate-200 dark:bg-slate-700 rounded"></div>
            <div class="flex gap-2">
                <div class="w-32 h-6 bg-slate-200 dark:bg-slate-700 rounded-full"></div>
                <div class="w-24 h-6 bg-slate-200 dark:bg-slate-700 rounded-full"></div>
            </div>
        </div>

        <!-- Fila Remitente + Adjunto Skeleton -->
        <div class="flex gap-4 flex-col sm:flex-row">
            <div class="h-14 bg-slate-100 dark:bg-slate-800/80 border border-slate-200/60 dark:border-slate-700/60 rounded-lg p-2.5 flex flex-col justify-between w-full sm:w-1/2">
                <div class="w-28 h-2.5 bg-slate-200 dark:bg-slate-700 rounded"></div>
                <div class="w-36 h-4 bg-slate-200 dark:bg-slate-700 rounded"></div>
            </div>
            <div class="h-14 bg-slate-100 dark:bg-slate-800/80 border border-slate-200/60 dark:border-slate-700/60 rounded-lg p-2.5 flex flex-col justify-between w-full sm:w-1/2">
                <div class="w-24 h-2.5 bg-slate-200 dark:bg-slate-700 rounded"></div>
                <div class="w-32 h-4 bg-slate-200 dark:bg-slate-700 rounded"></div>
            </div>
        </div>

        <!-- Asunto Skeleton -->
        <div class="h-14 bg-slate-100 dark:bg-slate-800/80 border border-slate-200/60 dark:border-slate-700/60 rounded-lg p-2.5 flex flex-col justify-between w-full">
            <div class="w-16 h-2.5 bg-slate-200 dark:bg-slate-700 rounded"></div>
            <div class="w-48 h-4 bg-slate-200 dark:bg-slate-700 rounded"></div>
        </div>

        <!-- Editor Skeleton -->
        <div class="border border-slate-200 dark:border-slate-700 rounded-lg overflow-hidden flex flex-col">
            <div class="h-10 bg-slate-100 dark:bg-slate-800 border-b border-slate-200 dark:border-slate-700 p-2 flex gap-2">
                <div class="w-6 h-6 bg-slate-200 dark:bg-slate-700 rounded"></div>
                <div class="w-6 h-6 bg-slate-200 dark:bg-slate-700 rounded"></div>
                <div class="w-6 h-6 bg-slate-200 dark:bg-slate-700 rounded"></div>
                <div class="w-16 h-6 bg-slate-200 dark:bg-slate-700 rounded ml-4"></div>
            </div>
            <div class="h-32 bg-slate-50 dark:bg-slate-900/50 p-3 space-y-2">
                <div class="w-full h-3 bg-slate-200 dark:bg-slate-700 rounded"></div>
                <div class="w-5/6 h-3 bg-slate-200 dark:bg-slate-700 rounded"></div>
                <div class="w-3/4 h-3 bg-slate-200 dark:bg-slate-700 rounded"></div>
            </div>
        </div>

        <!-- Botonera Skeleton -->
        <div class="w-full flex justify-end mt-auto pt-2 border-t border-gray-100">
            <div class="w-28 h-10 bg-slate-200 dark:bg-slate-700 rounded-lg"></div>
        </div>
    </div>

    <div *ngIf="!mostrarSpinner" class="w-full flex flex-col gap-3 p-4 overflow-y-auto flex-1 px-[1px]">
        <form class="flex flex-col sm:w-full md:w-full" [formGroup]="form">
            <div
                *ngIf="mostrarAdvertenciaDestinatarioSinEmail"
                class="destinatario-warning"
            >
                <mat-icon class="destinatario-warning__icon">warning</mat-icon>
                <span>
                    El {{ etiquetaDestinatario.toLowerCase() }} no tiene un
                    correo electr&oacute;nico cargado. De igual manera puede
                    agregar uno manualmente si lo desea.
                </span>
            </div>
            <div class="flex gap-4 mt-4 flex-col">
                <mat-form-field
                    subscriptSizing="dynamic"
                    appearance="fill"
                    class="field-bg-gray field-bg-gray w-full sm:flex-grow"
                    [class]="color_primario ? '' : default_color"
                >
                    <mat-label
                        class="inline-flex items-center gap-1 vertical-align-top"
                    >
                        <mat-icon
                            [style.color]="color_primario || ''"
                            class="icon-size-5"
                            [svgIcon]="'heroicons_outline:user-group'"
                        ></mat-icon>
                        {{ etiquetaDestinatario }}</mat-label
                    >
                    <mat-chip-grid
                        #chipgrid
                        formControlName="proveedor"
                        aria-label="Seleccione una opción"
                        class="sm:max-h-[50px] xl:max-h-[200px] max-h-[100px] overflow-y-auto flex flex-wrap gap-2"
                    >
                        <mat-chip-row
                            *ngFor="let email of selectedEmails"
                            [value]="email"
                            [style.background-color]="color_primario || ''"
                            (removed)="removeEmail(email)"
                        >
                            {{ email.mail }}
                            <button matChipRemove>
                                <mat-icon class="text-white">cancel</mat-icon>
                            </button>
                        </mat-chip-row>
                        <input
                            [matChipInputFor]="chipgrid"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            [matChipInputAddOnBlur]="addOnBlur"
                            (matChipInputTokenEnd)="addEmailFromInput($event)"
                            [matAutocomplete]="auto"
                            #proveedorInput
                        />
                    </mat-chip-grid>
                    <mat-autocomplete
                        #auto="matAutocomplete"
                        (optionSelected)="
                            selectProveedor($event, proveedorInput)
                        "
                    >
                        <mat-option
                            *ngFor="
                                let p of ((tipo === 'VENTAS'
                                    ? filteredClientes
                                    : esDestinatarioEmpleado
                                      ? filteredEmpleados
                                      : filteredProveedores
                                ) | async) ?? []
                            "
                            [value]="p"
                        >
                            {{
                                getTextGenerico(p) ||
                                    p.RazonSocial ||
                                    p.razonSocial ||
                                    p.Mail ||
                                    p.mail
                            }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error
                        *ngIf="
                            form.get('proveedor')?.touched &&
                            form
                                .get('proveedor')
                                ?.hasError('destinatarioRequerido')
                        "
                    >
                        Debe ingresar al menos un correo para
                        {{ etiquetaDestinatario.toLowerCase() }}.
                    </mat-error>
                </mat-form-field>

                <div class="flex gap-4 flex-col sm:flex-row">
                    <mat-form-field
                        subscriptSizing="dynamic"
                        appearance="fill"
                        class="field-bg-gray w-full sm:w-1/2"
                        [class]="color_primario ? '' : default_color"
                    >
                        <mat-label class="inline-flex items-center gap-1 vertical-align-top">
                            <mat-icon
                                [style.color]="color_primario || ''"
                                class="icon-size-5"
                                [svgIcon]="'heroicons_outline:identification'"
                            ></mat-icon>
                            Nombre Remitente (Alias)
                        </mat-label>
                        <input
                            matInput
                            type="text"
                            formControlName="nombre_remitente"
                            [matAutocomplete]="autoRemitente"
                            placeholder="Ej: Ventas Central"
                        />
                        <mat-autocomplete #autoRemitente="matAutocomplete">
                            <mat-option *ngFor="let remitente of filteredRemitentes | async" [value]="remitente">
                                {{ remitente }}
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>

                    <mat-form-field
                        subscriptSizing="dynamic"
                        appearance="fill"
                        class="field-bg-gray w-full sm:w-1/2"
                        [class]="color_primario ? '' : default_color"
                    >
                        <mat-label class="inline-flex items-center gap-1 vertical-align-top">
                            <mat-icon
                                [style.color]="color_primario || ''"
                                class="icon-size-5"
                                [svgIcon]="'heroicons_outline:document-text'"
                            ></mat-icon>
                            Nombre del Adjunto
                        </mat-label>
                        <input matInput type="text" formControlName="nombre_adjunto" placeholder="Nombre del archivo adjunto" />
                    </mat-form-field>
                </div>

                <mat-form-field
                    subscriptSizing="dynamic"
                    appearance="fill"
                    class="field-bg-gray field-bg-gray w-full sm:flex-grow"
                    [class]="color_primario ? '' : default_color"
                >
                    <mat-label
                        class="inline-flex items-center gap-1 vertical-align-top"
                    >
                        <mat-icon
                            [style.color]="color_primario || ''"
                            class="icon-size-5"
                            [svgIcon]="'heroicons_outline:chat-bubble-bottom-center-text'"
                        ></mat-icon>
                        Asunto</mat-label
                    >
                    <input matInput type="text" formControlName="asunto" />
                    <mat-error
                        *ngIf="
                            form.get('asunto')?.touched &&
                            !form.get('asunto')?.value?.trim()
                        "
                    >
                        Debe completar el asunto.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>

        <div class="w-full sm:w-full">
            <quill-editor
                [(ngModel)]="editorContent"
                [style]="{ height: '120px', width: '100%' }"
                [modules]="editorModules"
                [placeholder]="'Escribe algo aquí ...'"
            >
            </quill-editor>
        </div>

        <!-- Sección: Adjuntos -->
        <div *ngIf="permiteAdjunto" class="mt-2 w-full">
            <div class="flex items-center gap-2">
                <button
                    mat-icon-button
                    type="button"
                    matTooltip="Añadir Imagen"
                    [class]="color_primario ? '' : default_color"
                    [style.background-color]="color_primario || ''"
                    (click)="fileInput.click()"
                >
                    <mat-icon class="text-white transform -rotate-45"
                        >attach_file</mat-icon
                    >
                </button>
                <input
                    #fileInput
                    id="fileToUploadImagen"
                    type="file"
                    [accept]="validExtension"
                    (change)="setImagen($event, 0)"
                    class="hidden"
                />
                <small
                    *ngIf="adjuntos.length === 0"
                    class="text-muted cursor-pointer"
                    (click)="fileInput.click()"
                >
                    <b>{{ "Adjuntos" }}</b> (Max: 20Mb)
                </small>
                <!-- Archivos Nuevos / Guardados -->
                <div
                    *ngIf="adjuntos.length > 0"
                    class="mt-4 grid gap-2 p-2 bg-slate-200 rounded-lg max-w-full max-h-56 xl:max-h-56 sm:max-h-18 overflow-y-auto"
                    style="
                        grid-template-columns: repeat(
                            auto-fill,
                            minmax(200px, 1fr)
                        );
                    "
                >
                    <ng-container *ngFor="let imagen of adjuntos">
                        <div
                            [class]="color_primario ? '' : default_color"
                            [style.background-color]="color_primario || ''"
                            class="flex items-center gap-2 px-4 py-2 rounded-lg text-white"
                        >
                            <!-- Aquí agrego la clase truncate -->
                            <span class="truncate max-w-xs"
                                >{{ imagen.name }} ({{
                                    getFileSize(imagen.size)
                                }})</span
                            >
                            <button
                                mat-icon-button
                                (click)="removeFile('adjuntos', imagen)"
                            >
                                <mat-icon class="text-white">close</mat-icon>
                            </button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div class="w-full sm:flex sm:justify-end pt-3">
        <app-boton-dinamico
            [type]="'button'"
            [texto]="'Enviar'"
            [clases]="'button-default button-default--big text-white'"
            (click)="onSubmit()"
        ></app-boton-dinamico>
    </div>
</div>
